
import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      let errorMessage = 'An unexpected error occurred.';
      try {
        const errorData = JSON.parse(this.state.error?.message || '{}');
        if (errorData.error) {
          errorMessage = `Firestore Error: ${errorData.error} (Operation: ${errorData.operationType})`;
        }
      } catch (e) {
        errorMessage = this.state.error?.message || errorMessage;
      }

      return (
        <div className="min-h-screen bg-[#322D29] flex items-center justify-center p-6 text-white font-sans">
          <div className="max-w-md w-full bg-[#3a3430] border border-white/[0.06] rounded-xl p-8 sm:p-10 space-y-6 text-center shadow-2xl">
            <div className="w-14 h-14 bg-[#322D29] text-[#F26522] border border-white/[0.08] flex items-center justify-center mx-auto rounded-xl text-xl">
              <i className="fas fa-triangle-exclamation"></i>
            </div>
            <div className="space-y-2">
              <h2 className="text-lg font-bold uppercase tracking-wider font-heading text-white">System Alert</h2>
              <p className="text-xs font-medium text-white/60 leading-relaxed font-dm">
                {errorMessage}
              </p>
            </div>
            <button 
              onClick={() => window.location.reload()}
              className="w-full py-3.5 bg-[#F26522] hover:bg-[#F26522]/90 text-white text-[11px] font-bold uppercase tracking-[0.2em] font-heading rounded-lg transition-colors cursor-pointer"
            >
              Reboot Node
            </button>
          </div>
        </div>
      );
    }

    return (this as any).props.children;
  }
}

export default ErrorBoundary;
